import ServiceManager from '../../service/ServiceManager';

import { data } from '../../constants/Constants';
import { getDevice } from './utilApi';
export function getData(dealer, linea, asociado) {
    const DispositivoId = getDevice();
    let params = {};
    params.url = "dealer/ListarDashboard";
    params.data = {
        'dto.CodigoDealer': dealer.codcliente,
        'dto.OriginalCodigoDealer': dealer.originalcodcliente,
        'dto.Vkorg': linea.vkorg,
        'dto.DispositivoDealer': DispositivoId,
        'dto.CorreoElectronicoDealer': dealer.correoElectronico,
        'dto.Pagenumber': 1,
        'dto.Pagesize': data.PageSizeToAlerta,
        'dto.Region': asociado.poblacion,
        'dto.Linea': linea.linea,
        'dto.Centro': linea.centro,
        'dto.Almacen': linea.almacen,
        'dto.Sector': linea.sector,
        'dto.Canal': linea.canal,
        'dto.Moneda': asociado.moneda,
        'dto.Poblacion': asociado.poblacion,
        'dto.Sistema': data.Sistema
    };
    console.log("ListarDashboard=====>", params.data);
    return ServiceManager.prototype.Post(params);
}